import React from 'react';
import Link from '../Link';
export default function ShareTab({ name, children, isActive, onClick }) {
    return (React.createElement(Link, { color: isActive ? 'licorice' : 'slate', "data-testid": `${name}-collaborators-tab`, fontSize: 14, fontWeight: isActive ? 600 : 400, hoverColor: "licorice", lineHeight: 1, marginBottom: 10, marginRight: [12, 3, 4], onClick: onClick }, children));
}
